import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { distanciaKm, normalizarCoordenadas, RADIO_CERCA_KM } from "./distancia";

const TTL_MS = 5 * 60 * 1000;
let cache = { at: 0, tiendas: null };

// Las tiendas cambian poco: se guardan unos minutos para no releerlas en cada pantalla.
const cargarTiendas = async () => {
  if (cache.tiendas && Date.now() - cache.at < TTL_MS) return cache.tiendas;
  const snap = await getDocs(collection(db, "tiendas"));
  const tiendas = snap.docs
    .map((d) => ({ ...d.data(), vendedorUid: d.id }))
    .filter((t) => t.activado !== false && !t.pausa && !t.blacklist);
  cache = { at: Date.now(), tiendas };
  return tiendas;
};

export const obtenerTiendasActivas = cargarTiendas;

export const invalidarCacheTiendas = () => {
  cache = { at: 0, tiendas: null };
};

/**
 * Tiendas ordenadas por distancia al usuario.
 *  - radioKm: solo tiendas dentro del radio (Infinity = todas, solo ordenadas).
 *  - Si no hay ninguna dentro del radio, devuelve las más cercanas marcadas con fueraDeRango.
 *  - Las tiendas sin coordenadas válidas nunca se consideran "cercanas".
 */
export const obtenerTiendasCercanas = async (
  ubicacionUsuario,
  { radioKm = RADIO_CERCA_KM, respaldo = 3 } = {}
) => {
  const origen = normalizarCoordenadas(ubicacionUsuario);
  const tiendas = await cargarTiendas();
  if (!origen) return [];

  const conDistancia = tiendas
    .map((t) => ({ ...t, distancia: distanciaKm(origen, t.ubicacion) }))
    .filter((t) => Number.isFinite(t.distancia))
    .sort((a, b) => a.distancia - b.distancia);

  const dentro = conDistancia.filter((t) => t.distancia <= radioKm);
  if (dentro.length > 0 || respaldo <= 0) return dentro;
  return conDistancia.slice(0, respaldo).map((t) => ({ ...t, fueraDeRango: true }));
};
